module.exports = __webpack_public_path__ + "static/media/logo_blue.d24b1831.png";